import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import UserUnitList from "./UserUnitList";

class WinterUnitsListWrapper extends Component {
  handleScrollTo(top) {
    const { scrollbars } = this.refs;

    if (scrollbars) scrollbars.scrollTop(top);
  }

  render() {
    return (
      <Scrollbars style={{ height: "100%" }} autoHide={true} ref="scrollbars">
        <UserUnitList handleScrollTo={this.handleScrollTo.bind(this)} />
      </Scrollbars>
    );
  }
}

export default WinterUnitsListWrapper;
